import { Card, Typography, CardContent, Grid, CardHeader, Divider } from "@mui/material";
import { FaTrash, FaPencilAlt, FaRegTimesCircle, FaRegCheckCircle } from "react-icons/fa";
import { FaClockRotateLeft } from "react-icons/fa6";
import { IconType } from "react-icons/lib";

const STATUS_STYLES = {
  total: { backgroundColor: "#DAE3F5", color: "#354197" },
  pedente: { backgroundColor: "#FCF9C7", color: "#C8BA36" },
  assinado: { backgroundColor: "#CEE9D1", color: "#6DD084" },
  recusado: { backgroundColor: "#FDB8BD", color: "#D32F2F" },
};

interface GestaoAssinaturaDashboardProps {
  valueTotal: number;
  labelTotal: string;
  valuePending: number;
  labelPending: string;
  valueSigned: number;
  labelSigned: string;
  valueRefused: number;
  labelRefused: string;
  title: string;
  canceledDocuments: number;
}

interface StatusCardProps {
  icon: IconType;
  value: number;
  label: string;
  style: React.CSSProperties;
}

const DIVIDER_STYLES = { backgroundColor: "rgba(0, 0, 0, 0.50)", width: "1px", height: "60px" };

const StatusCard = ({ icon: Icon, value, label, style }: StatusCardProps) => {
  return (
    <Grid
      item
      xs
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 10,
        borderRadius: 8,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: 40,
          marginBottom: 8,
        }}
      >
        <span
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 32,
            height: 32,
            backgroundColor: style.backgroundColor,
            borderRadius: 4,
            ...style,
          }}
        >
          <Icon size={16} color={style.color} />
        </span>
        <Typography
          variant="h4"
          style={{
            marginLeft: 8,
            fontSize: 24,
            lineHeight: 1,
            display: "flex",
            alignItems: "center",
            height: 32,
          }}
        >
          {value}
        </Typography>
      </div>
      <Typography variant="body2" style={{ textAlign: "center", width: "100%", whiteSpace: "nowrap" }}>
        {label}
      </Typography>
    </Grid>
  );
};

const GestaoAssinaturaDashboard = ({
  valueTotal,
  labelTotal,
  valuePending,
  labelPending,
  valueSigned,
  labelSigned,
  valueRefused,
  labelRefused,
  title,
  canceledDocuments,
}: GestaoAssinaturaDashboardProps) => {
  return (
    <Grid container spacing={3} style={{ marginTop: 25, justifyContent: "center" }}>
      <Grid item xs={12} md={10} lg={8}>
        <Card>
          <CardHeader
            title={title}
            titleTypographyProps={{ variant: "body2", color: "textSecondary", sx: { fontSize: 16 } }}
            action={
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <FaTrash size={16} color="gray" />
                <Typography variant="body2" color="textSecondary">
                  Documentos cancelados: {canceledDocuments}
                </Typography>
              </div>
            }
          />
          <CardContent>
            <Grid container spacing={2} alignItems="center" justifyContent="center">
              <StatusCard icon={FaPencilAlt} value={valueTotal} label={labelTotal} style={STATUS_STYLES.total} />
              <Divider style={DIVIDER_STYLES} orientation="vertical" flexItem />
              <StatusCard
                icon={FaClockRotateLeft}
                value={valuePending}
                label={labelPending}
                style={STATUS_STYLES.pedente}
              />
              <Divider style={DIVIDER_STYLES} orientation="vertical" flexItem />
              <StatusCard
                icon={FaRegCheckCircle}
                value={valueSigned}
                label={labelSigned}
                style={STATUS_STYLES.assinado}
              />
              <Divider style={DIVIDER_STYLES} orientation="vertical" flexItem />
              <StatusCard
                icon={FaRegTimesCircle}
                value={valueRefused}
                label={labelRefused}
                style={STATUS_STYLES.recusado}
              />
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default GestaoAssinaturaDashboard;
